<article class="container" *ngIf="showFallback">
  <ifc-mobile-app-banner></ifc-mobile-app-banner>
</article>
